import { configureStore } from "@reduxjs/toolkit";
import urlReducer from "./UrlSlice";

export const store = configureStore({
  reducer: {
    url: urlReducer,
  },
});
